module.exports = __webpack_public_path__ + "img/btn_hp.84b1379d.png";